import React from 'react';
import Home from '../App/components/Home';
// import NavBar from '../App/components/NavBar';

function HomePage() {
  return (
    <>
    <Home />
    </>
  );
}

export default HomePage;
